import { render } from "./Center_Introduction.vue?vue&type=template&id=72a19020"
import script from "./Center_Introduction.vue?vue&type=script&lang=js"
export * from "./Center_Introduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__